import React from 'react';
import { useLocation } from "react-router-dom";

import GetAllPodcastEpisodes from '../../../hooks/getAllPodcastEpisodes';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import SwiperCore, { Navigation } from 'swiper';
import useIsMobile from '../../../hooks/useIsMobile';

import '../resources/BlogCardSwiper/BlogCardSwiper.css';
import EpisodeCard from './EpisodeCard';

function PodcastCardSwiper() {

    const { state } = useLocation();
    let { all_episodes } = GetAllPodcastEpisodes(state); 
    const isMobile = useIsMobile(675);

    return (
        <div className="blog-card-swiper-container">
            <Swiper
                key={isMobile ? 'mobile' : 'desktop'}
                slidesPerView={1}
                slidesPerGroup={1}
                navigation
                spaceBetween={10}
                pagination={{
                ...(isMobile && {
                    dynamicBullets: true,
                    dynamicMainBullets: 5,
                }), // limit bullets on mobile, otherwise don't 
                clickable: true,
                renderBullet: function(index, className) {
                    return '<span class="' + className + '"><img class="pagination-bullet" alt=""/></span>';
                }
                }}
                breakpoints={{
                    590: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetween: 10,
                    },
                    675: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 10,
                    },
                    875: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 20,
                    },
                    1040: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 20,
                    },
                    1230: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 20,
                    },
                    1900: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        spaceBetween: 20,
                    },
                }}
                modules={[Navigation, Pagination]}
                centerInsufficientSlides={true}
                className="podcastCardSwiper"
            >
                {all_episodes.map((episode, index) => 
                    <SwiperSlide key={index}>
                        <EpisodeCard
                            series_number={episode.series_number}
                            episode_number={episode.episode_number}
                            name={episode.name}
                            job_title={episode.job_title}
                            company={episode.company}
                            description={episode.teaser_line}
                        />
                    </SwiperSlide>
                )}
              </Swiper>
        </div>  
    )
}

export default PodcastCardSwiper;